<template>
    <div class="ind1">
        <div class="ind2" :style="{background: bg1}">
            <div class="ind4">
                <div class="ind5">契合综合触客营销平台
                一站式精准触客高活跃流量</div>
                <div class="ind6">契合综合触客营销平台，有针对性的触客营销，打通公私域联动，公域平台覆盖广。私域流量管理细，流量综合治理，画像清晰活跃度高，一站式完成高质量触客。</div>
                <div style="width: 100%;float: left;"></div>
                <div class="ind7" @click="tapTch1" style="cursor: pointer;">立即试用</div>
                <div class="ind8" @click="tapTch8" style="cursor: pointer;">了解更多</div>
            </div>
        </div>
        <div class="ind59" :style="{background: bg3}">
            <div class="ind4">
                <div class="ind9">自建及代运营私域</div>
                <div class="ind10"><span class="ind14">· </span>自建及代运营企业微信（后台）<span class="ind11">近百个</span>
                <br/><span class="ind14">· </span>公众号<span class="ind11">40余个</span>
                <br/><span class="ind14">· </span>企业微信及个人微信群<span class="ind11">3000余个</span>
                <br/><span class="ind14">· </span>代运营触客累计<span class="ind11">2000万</span></div>
                <img src="../../assets/ychy/img12.png" class="ind12">
                <div class="ind13"><span class="ind14">· </span>引流入池：全场景布局设计 多能力支撑 
                <span class="ind14">· </span>流量留存：标签体系搭建 品牌粘性培育 
                <span class="ind14">· </span>运营转化：连接价值与需求 搭建精细化体系
                <span class="ind14">· </span>数据复盘：全环节数据监控 运营策略调优</div>
            </div>
        </div>
        <div class="ind15" :style="{background: bg2,'background-size': 'cover'}">
            <div class="ind17">
                <div class="ind18">合作共建运营私域</div>
                <div class="ind19">
                    <div class="ind20" style="margin-left: 0;width: 210px;">
                        <div class="ind60">
                            <img src="../../assets/ychy/img31.png" style="width: 68px;height: 68px;">
                        </div>
                        <div class="ind21">联建平台</div>
                        <img src="../../assets/ychy/img32.png" class="ind61">
                        <div class="ind22">与合作伙伴共同打造引流平台，共建池内私域生态；通过挪车码、小游戏等功能端口导入流量，具有客户数据完善、画像精准、活跃度高等特点，是十分优质的私域流量。
                            
                        例如：与“辽宁省校友经济促进会”共同打造的高校校友互动社交平台“同门客栈”。</div>
                    </div>
                    <div class="ind20" style="width: 224px;">
                        <div class="ind60">
                            <img src="../../assets/ychy/img33.png" style="width: 73px;height: 64px;">
                        </div>
                        <div class="ind21">线下场景</div>
                        <img src="../../assets/ychy/img32.png" class="ind61">
                        <div class="ind22">拥有千余家线下场景合作机构及商户，包括各类重点商圈商户（实现头部shopping mall全覆盖，以及餐饮、商超、便利店、生鲜超市等）、时令性热点（集市、夜市、快闪等）、文娱场景（电影院、健身场馆等）、文博场所（图书馆、博物馆、科技馆等）、出行场景（公共交通、加油站、停车场等）。</div>
                    </div>
                    <div class="ind20" style="width: 140px;">
                        <div class="ind60">
                            <img src="../../assets/ychy/img28.png" style="width: 64px;height: 69px;">
                        </div>
                        <div class="ind21">B端共建</div>
                        <img src="../../assets/ychy/img32.png" class="ind61">
                        <div class="ind22">与所服务的银行收单商户及服务类APP平台入驻商家，通过B端私域共建，以更精细运营，赋予客户更高价值，获得客户依从度，和不单单基于礼品的粘性，从而实现更加顺畅的高质量转化。</div>
                    </div>
                    <div class="ind20" style="width: 118px;">
                        <div class="ind60">
                            <img src="../../assets/ychy/img29.png" style="width: 73px;height: 54px;">
                        </div>
                        <div class="ind21">端口流量</div>
                        <img src="../../assets/ychy/img32.png" class="ind61">
                        <div class="ind22">与知名头部物业运营商（恒大、万科等）及社区和村镇等基层组织共同合作，打造深入业主/居民一线的流量入口，获取一手直接流量，合作渠道覆盖量达百万人。</div>
                    </div>
                    <div class="ind20" style="width: 110px;">
                        <div class="ind60">
                            <img src="../../assets/ychy/img30.png" style="width: 73px;height: 62px;">
                        </div>
                        <div class="ind21">供应商体系</div>
                        <img src="../../assets/ychy/img32.png" class="ind61">
                        <div class="ind22">与活动商品供应商在供需合作的同时，进行流量互换，综合治理，利用供应商自有的完整体系覆盖能力，自上而下进行推广宣传和运营管理。</div>
                    </div>
                </div>
                <div class="ind27" style="color: #fff;margin-left: 60px;margin-top: 70px;">合作渠道：</div>
                <img src="../../assets/ychy/img43.png" class="ind28" style="margin-left: 60px;">
                <img src="../../assets/ychy/img37.png" class="ind28">
                <img src="../../assets/ychy/img38.png" class="ind28">
                <img src="../../assets/ychy/img42.png" class="ind28">
                <img src="../../assets/ychy/img41.png" class="ind28">
                <img src="../../assets/ychy/img39.png" class="ind28">
                <img src="../../assets/ychy/img40.png" class="ind28">
                <img src="../../assets/ychy/img44.png" class="ind28">
            </div>
        </div>
        <div class="ind62" :style="{background: bg4}">
            <div class="ind23">公域拓展引流及留存</div>
            <div class="ind4">
                <div class="ind24"><span class="ind25">· </span>运营协助超便捷 
                <span class="ind25">· </span>视频矩阵系统账号授权 
                <span class="ind25">· </span>智能矩阵发布智能自复 
                <span class="ind25">· </span>智能接待系统私信评论 
                <span class="ind25">· </span>自动回复微信名片、H5引流
                <span class="ind25">· </span>定时发布/间隔发布
                <span class="ind25">· </span>合作MCN机构30余家，近200名KOL，可触粉丝近1个亿</div>
                <img src="../../assets/ychy/img5.png" class="ind26">
            </div>
        </div>
        <div class="footer" style="width: 100%;float: left;min-height: 484px !important;">
            <contain></contain>
        </div>

        <div class="ind58" v-if="tch1">
            <div class="ind29">
                <img src="../../assets/ychy/img18.png" class="ind16">
                <div class="ind17" style="width: 100%;float: left;">
                    <div class="ind30">同门客栈介绍</div>
                    <img src="../../assets/ychy/img20.png" class="ind31" @click="tapTch2" style="cursor: pointer;">
                    <img src="../../assets/ychy/img19.png" class="ind32">
                    <div class="ind33">同门客栈是中国高校校友“交友娱乐、互助成长、拓展人脉”的社交平台；是“实名制、认证制、推荐制”的靠谱校友社群；是立足“本地生活”的同频人的线下聚集地；是“人人都可以搞活动”的梦工厂！</div>
                    <div class="ind34" @click="tapTCh3" style="cursor: pointer;">下一步 选择客户群</div>
                </div>
            </div>
        </div>
        
        <div class="ind58" v-if="tch2">
            <div class="ind35">
                <img src="../../assets/ychy/img21.png" class="ind16">
                <div class="ind17" style="width: 100%;float: left;">
                    <div class="ind30">选择客户群</div>
                    <img src="../../assets/ychy/img20.png" class="ind31" @click="tapTch2" style="cursor: pointer;">
                    <div class="ind36">全部客户群 (624)</div>
                    <div class="ind37" v-for="(item,index) in list" style="cursor: pointer;" :key="item" @click="tapCH(index)" :style="{'margin-left': index%2==0?'56px':'37px','border': !item.choose?'unset':''}">
                        <div class="ind38">{{item.name}}</div>
                        <div class="ind39">{{index%2==0?200:161}}名客户丨{{index%2==0?78:46}}%日活</div>
                        <img src="../../assets/ychy/img22.png" class="ind40" v-if="item.choose">
                    </div>
                    <div style="float: left;width: 100%;"></div>
                    <div class="ind41">已选{{num}}个客户群丨含1221名客户</div>
                    <div class="ind42">
                        <div style="float: right;">
                            <div class="ind43" style="font-size: 20px;cursor: pointer;" @click="tapPre">&lt;</div>
                            <div class="ind43" @click="tapFZH(Math.ceil(zshu/10)-ind>=3?ind:(Math.ceil(zshu/10)<4?1:Math.ceil(zshu/10)-3))" v-if="Math.ceil(zshu/10)>1" :style="{'cursor': 'pointer','background': ind==(Math.ceil(zshu/10)-ind>=3?ind:(Math.ceil(zshu/10)<4?1:Math.ceil(zshu/10)-3))?'#5077EF':'',color: ind==(Math.ceil(zshu/10)-ind>=3?ind:(Math.ceil(zshu/10)<4?1:Math.ceil(zshu/10)-3))?'#fff':''}">{{Math.ceil(zshu/10)-ind>=3?ind:(Math.ceil(zshu/10)<4?1:Math.ceil(zshu/10)-3)}}</div>
                            <div class="ind43" @click="tapFZH(Math.ceil(zshu/10)==3?2:(Math.ceil(zshu/10)-ind>=3?ind+1:Math.ceil(zshu/10)-2))" v-if="Math.ceil(zshu/10)>2" :style="{'cursor': 'pointer','background': ind==(Math.ceil(zshu/10)==3?2:(Math.ceil(zshu/10)-ind>=3?ind+1:Math.ceil(zshu/10)-2))?'#5077EF':'','color': ind==(Math.ceil(zshu/10)==3?2:(Math.ceil(zshu/10)-ind>=3?ind+1:Math.ceil(zshu/10)-2))?'#fff':''}">{{Math.ceil(zshu/10)==3?2:(Math.ceil(zshu/10)-ind>=3?ind+1:Math.ceil(zshu/10)-2)}}</div>
                            <div class="ind43" @click="tapFZH(Math.ceil(zshu/10)==4?3:Math.ceil(zshu/10)-ind<=3?Math.ceil(zshu/10)-1:'...')" :style="{'cursor': 'pointer','font-size': '18px','background': ind==(Math.ceil(zshu/10)==4?3:Math.ceil(zshu/10)-ind<3?Math.ceil(zshu/10)-1:'...')?'#5077EF':'','color': ind==(Math.ceil(zshu/10)==4?3:Math.ceil(zshu/10)-ind<3?Math.ceil(zshu/10)-1:'...')?'#fff':''}" v-if="Math.ceil(zshu/10)>=4">{{Math.ceil(zshu/10)==4?3:Math.ceil(zshu/10)-ind<=3?Math.ceil(zshu/10)-1:'...'}}</div>
                            <div class="ind43" @click="tapFZH(Math.ceil(zshu/10))" :style="{'cursor': 'pointer','background': ind==Math.ceil(zshu/10)?'#5077EF':'','color': ind==Math.ceil(zshu/10)?'#fff':''}">{{Math.ceil(zshu/10)}}</div>
                            <div class="ind43" style="font-size: 20px;cursor: pointer;" @click="tapNext">&gt;</div>
                        </div>
                        <!-- <div>
                            <div class="ind44">跳至</div>
                            <input type="number" class="ind45" @input="inpN" v-model="yshu" @blur="blurN">
                            <div class="ind44">页</div>
                        </div> -->
                    </div>
                    <div class="ind46" @click="tapTCh4" style="cursor: pointer;">上一步 触客渠道</div>
                    <div class="ind47" @click="tapTCh5" style="cursor: pointer;">下一步 联系客户经理</div>
                </div>
            </div>
        </div>

        <div class="ind58" v-if="tch3">
            <div class="ind48">
                <img src="../../assets/ychy/img23.png" class="ind16">
                <div class="ind17" style="width: 100%;float: left;">
                    <div class="ind30">联系客户经理</div>
                    <img src="../../assets/ychy/img20.png" class="ind31" @click="tapTch2" style="cursor: pointer;">
                    <img src="../../assets/code.png" class="ind49">
                    <div class="ind50">扫描上方二维码，添加客户经理企业微信 
                    即可发送推送内容，并可以咨询相关费用及营销方案</div>
                    <div class="ind51" @click="tapTCh6" style="cursor: pointer;">上一步 选择客户群</div>
                    <div class="ind52" @click="tapTch7" style="cursor: pointer;">完成</div>
                </div>
            </div>
        </div>

        <div class="ind58" v-if="tch4">
            <div class="ind53">
                <img src="../../assets/ychy/img24.png" class="ind16">
                <div class="ind17" style="width: 100%;float: left;">
                    <div class="ind54">了解更多</div>
                    <img src="../../assets/ychy/img20.png" class="ind55" @click="tapTch2" style="cursor: pointer;">
                    <img src="../../assets/code.png" class="ind56">
                    <div class="ind57">扫描上方二维码，添加客户经理企业微信 
                    即可咨询更多相关功能介绍及开通流程</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import contain from "../../components/contain.vue";
export default {
    data() {
        return {
            tch1: false,
            tch2: false,
            tch3: false,
            tch4: false,
            zshu: 624,
            ind: 1,
            yshu: '',
            list: [
                {name: '同门羽动江湖一群',choose: true},
                {name: '同门羽动江湖二群',choose: false},
                {name: '同门吃货一群',choose: false},
                {name: '同门吃货二群',choose: false},
                {name: '同门燃脂江湖运动群一群',choose: false},
                {name: '同门燃脂江湖运动群二群',choose: false},
                {name: '同门篮球.脱单星球',choose: false},
                {name: '同门露营·花式周末一群',choose: false},
                {name: '同门露营·花式周末二群',choose: false},
                {name: '同门英语沙龙TMEC',choose: false}
                ],
            num: 1,
            bg1: 'url('+ require('../../assets/ychy/img3.png')+') no-repeat center top',
            bg2: 'url('+ require('../../assets/ychy/img27.png')+') no-repeat center top',
            bg3: 'url('+ require('../../assets/ychy/img25.png')+') no-repeat center top',
            bg4: 'url('+ require('../../assets/ychy/img26.png')+') no-repeat center top'
        };
    },
    components: { contain },
    mounted() {
        
    },
    methods: {
       tapTch1(){
            if(this.tch2||this.tch3||this.tch4){
                return;
            }

            this.tch1=true;
       },
       tapTch2(){
            this.tch1=false;
            this.tch2=false;
            this.tch3=false;
            this.tch4=false;
       },
       tapTCh3(){
            this.tch1=false;
            this.tch2=true;
       },
       tapTCh4(){
            this.tch2=false;
            this.tch1=true;
       },
       tapTCh5(){
            if(this.num==0){
                this.$toast('请至少选择一个客户群');

                return;
            }

            this.tch2=false;
            this.tch3=true;
       },
       tapTCh6(){
            this.tch3=false;
            this.tch2=true;
       },
       tapTch7(){
            this.tch3=false;
       },
       tapTch8(){
            if(this.tch2||this.tch3||this.tch1){
                return;
            }

            this.tch4=true;
       },
       tapPre(){
            // if(this.ind>1){
            //     this.ind-=1;
            // }
            this.tapTCh5();
       },
       tapNext(){
            // if(this.ind!=Math.ceil(this.zshu/10)){
            //     this.ind+=1;
            // }
            this.tapTCh5();
       },
       inpN(){
            if(this.yshu.length>Math.ceil(this.zshu/10).toString().length){
                this.yshu=this.yshu.substr(0,Math.ceil(this.zshu/10).toString().length);
            }
       },
       blurN(){
            // if(parseInt(this.yshu)<1){
            //     this.$toast('页数不能为负');
            // }else if(parseInt(this.yshu)>Math.ceil(this.zshu/10)){
            //     this.$toast('没有更多了');
            // }else{
            //     this.ind=parseInt(this.yshu);
            // }
            this.tapTCh5();
       },
       tapFZH(e){
            // if(e=='...'){
            //     return;
            // }

            // this.ind=e;
            this.tapTCh5();
       },
       tapCH(e){
            if(this.list[e].choose){
                this.num-=1;
            }else{
                this.num+=1;
            }

            this.list.splice(e,1,{name: this.list[e].name,choose: !this.list[e].choose});
       }
    }
}
</script>

<style scoped>
.ind1{
    width: 100%;
    float: left;
}
.ind2{
    width: 100%;
    height: 600px;
    float: left;
    position: relative;
}
.ind3{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
.ind4{
    width: 1200px;
    position: relative;
    margin: 0 auto;
}
.ind5{
    font-size: 42px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 60px;
    float: left;
    margin-top: 129px;
    white-space: pre-line;
    text-align: left;
}
.ind6{
    width: 632px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 30px;
    float: left;
    text-align: justify;
    margin-top: 16px;
    clear: both;
}
.ind7{
    width: 186px;
    height: 67px;
    border: 2px solid #FFFFFF;
    border-radius: 8px;
    box-sizing: border-box;
    float: left;
    margin-top: 51px;
    float: left;
    text-align: center;
    line-height: 63px;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
}
.ind8{
    width: 186px;
    height: 67px;
    border: 2px solid #FFFFFF;
    border-radius: 8px;
    box-sizing: border-box;
    float: left;
    margin-top: 51px;
    float: left;
    margin-left: 34px;
    text-align: center;
    line-height: 63px;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
}
.ind9{
    width: 100%;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #313131;
    line-height: 1;
    text-align: center;
    float: left;
    margin-top: 84px;
}
.ind10{
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #393939;
    line-height: 43px;
    float: left;
    margin-top: 36px;
    margin-left: 6px;
    float: left;
    white-space: pre-line;
    text-align: left;
}
.ind11{
    color: #5077EF;
    font-weight: bold;
    font-size: 24px;
}
.ind12{
    width: 569px;
    float: right;
    margin-top: 59px;
}
.ind13{
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #393939;
    line-height: 40px;
    float: left;
    margin-top: 12px;
    margin-left: 6px;
    white-space: pre-line;
    text-align: left;
}
.ind14{
    font-weight: bold;
}
.ind15{
    width: 100%;
    float: left;
    height: 780px;
    position: relative;
}
.ind16{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
.ind17{
    width: 1200px;
    margin: 0 auto;
    position: relative;
}
.ind18{
    width: 100%;
    line-height: 1;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff;
    text-align: center;
    float: left;
    margin-top: 67px;
}
.ind19{
    width: 100%;
    float: left;
    margin-top: 60px;
    display: flex;
    justify-content: center;
}
.ind20{
    width: 185px;
    position: relative;
    margin-left: 65px;
}
.ind21{
    width: 100%;
    line-height: 1;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fff;
    text-align: center;
    margin: 26px auto;
    margin-bottom: 0;
}
.ind22{
    width: 100%;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff;
    line-height: 19px;
    margin: 21px auto;
    margin-bottom: 0;
    text-align: justify;
    white-space: pre-line;
    word-break: break-all;
}
.ind23{
    width: 100%;
    line-height: 1;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #313131;
    float: left;
    text-align: center;
    margin-top: 60px;
}
.ind24{
    font-size: 22px;
    font-family: Microsoft YaHei;
    color: #393939;
    line-height: 39px;
    float: left;
    margin-left: 6px;
    margin-top: 40px;
    white-space: pre-line;
    text-align: left;
}
.ind25{
    font-weight: bold;
}
.ind26{
    width: 378px;
    float: right;
    margin-top: 61px;
    margin-right: 64px;
}
.ind27{
    width: 100%;
    line-height: 1;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #7E7E7E;
    float: left;
    margin-top: 34px;
    text-indent: 7px;
    text-align: left;
}
.ind28{
    width: 75px;
    float: left;
    margin-top: 23px;
    margin-left: 15px;
    margin-bottom: 57px;
}
.ind29{
    width: 711px;
    height: 635px;
    position: relative;
}
.ind30{
    width: 100%;
    text-align: center;
    margin-top: 59px;
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1F1F1F;
    line-height: 1;
}
.ind31{
    width: 21px;
    position: absolute;
    top: 52px;
    right: 68px;
}
.ind32{
    width: 578px;
    float: left;
    margin-top: 43px;
    margin-left: 66px;
}
.ind33{
    width: 577px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #6B6B6B;
    line-height: 26px;
    float: left;
    margin-top: 24px;
    margin-left: 67px;
    text-align: justify;
}
.ind34{
    width: 342px;
    height: 66px;
    background: #5077EF;
    border-radius: 8px;
    float: left;
    text-align: center;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 66px;
    margin-top: 28px;
    margin-left: 184px;
}
.ind35{
    width: 835px;
    height: 815px;
    position: relative;
}
.ind36{
    width: 100%;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #5077EF;
    line-height: 1;
    margin-top: 34px;
    margin-bottom: 17px;
}
.ind37{
    width: 343px;
    height: 71px;
    background: #EFF4FF;
    border: 1px solid #2749B0;
    border-radius: 8px;
    box-sizing: border-box;
    float: left;
    margin-bottom: 19px;
}
.ind38{
    width: 100%;
    line-height: 1;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333C4B;
    float: left;
    margin-top: 17px;
    text-indent: 20px;
    text-align: left;
}
.ind39{
    line-height: 1;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #737B89;
    float: left;
    margin-top: 12px;
    margin-left: 20px;
}
.ind40{
    width: 24px;
    margin-top: 1px;
    float: right;
    margin-right: 13px;
}
.ind41{
    line-height: 1;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #5077EF;
    float: left;
    margin-top: 23px;
    margin-left: 56px;
}
.ind42{
    width: 370px;
    height: 25px;
    float: right;
    margin-right: 57px;
    margin-top: 20px;
}
.ind43{
    width: 35px;
    height: 25px;
    background: #FFFFFF;
    border: 1px solid #B3B3B3;
    border-radius: 4px;
    box-sizing: border-box;
    float: left;
    margin-left: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #B3B3B3;
    line-height: 1;
    position: relative;
}
.ind44{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #B3B3B3;
    line-height: 1;
    float: left;
    margin-top: 6px;
}
.ind45{
    width: 35px;
    height: 25px;
    background: #FFFFFF;
    border: 1px solid #B3B3B3;
    border-radius: 4px;
    box-sizing: border-box;
    margin-left: 9px;
    margin-right: 9px;
    float: left;
    text-align: center;
}
.ind46{
    width: 342px;
    height: 66px;
    background: #5077EF;
    opacity: 0.61;
    border-radius: 8px;
    float: left;
    margin-top: 35px;
    margin-left: 56px;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 66px;
    text-align: center;
    color: #FFFFFF;
}
.ind47{
    width: 342px;
    height: 66px;
    background: #5077EF;
    border-radius: 8px;
    float: left;
    margin-top: 30px;
    margin-left: 38px;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 66px;
    text-align: center;
}
.ind48{
    width: 835px;
    height: 635px;
    position: relative;
}
.ind49{
    width: 230px;
    height: 230px;
    background: #C7DDFF;
    float: left;
    margin-top: 56px;
    margin-left: 303px;
}
.ind50{
    width: 100%;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #6B6B6B;
    line-height: 26px;
    text-align: center;
    margin-top: 23px;
    float: left;
    white-space: pre-line;
}
.ind51{
    width: 342px;
    height: 66px;
    background: #5077EF;
    opacity: 0.61;
    border-radius: 8px;
    float: left;
    margin-top: 43px;
    margin-left: 56px;
    color: #fff;
    text-align: center;
    line-height: 66px;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
}
.ind52{
    width: 342px;
    height: 66px;
    background: #5077EF;
    border-radius: 8px;
    float: left;
    margin-top: 43px;
    margin-left: 38px;
    color: #fff;
    text-align: center;
    line-height: 66px;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
}
.ind53{
    width: 624px;
    height: 539px;
    position: relative;
}
.ind54{
    width: 100%;
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1F1F1F;
    line-height: 1;
    text-align: center;
    margin-top: 59px;
    float: left;
}
.ind55{
    width: 20px;
    position: absolute;
    top: 52px;
    right: 68px;
}
.ind56{
    width: 230px;
    height: 230px;
    background: #C7DDFF;
    float: left;
    margin-top: 50px;
    margin-left: 197px;
}
.ind57{
    width: 100%;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #6B6B6B;
    line-height: 26px;
    margin-top: 23px;
    text-align: center;
    float: left;
    white-space: pre-line;
}
.ind43:active::before{
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000;
    opacity: 0.3;
}
.ind58{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
.ind59{
    width: 100%;
    height: 562px;
    float: left;
    position: relative;
}
.ind60{
    width: 80px;
    height: 80px;
    margin: 4px auto;
    margin-bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
.ind61{
    width: 28px;
    margin: 18px auto;
    margin-bottom: 0;
}
.ind62{
    width: 100%;
    height: 480px;
    float: left;
    position: relative;
}
</style>


// WEBPACK FOOTER //
// src/views/ychy/zhchkpt.vue